import React, { useState, useEffect } from "react";
import { useGet } from "../../customHooks/useGet";
import UsersTable from "./UsersTable";
import UserForm from "./UserForm";
import { FaPlus } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";

const API_BASE_URL = "https://ectech-software.com.ar/api/core/users?page=0&size=200";

function Users() {
  const { data: usersData, loading, error, refetch } = useGet(API_BASE_URL);
  const [users, setUsers] = useState([]);
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    if (Array.isArray(usersData?.content)) {
      setUsers(usersData.content);
    } else if (Array.isArray(usersData)) {
      setUsers(usersData);
    }
  }, [usersData]);

  const updateUsers = (newUser) => {
    setUsers((prevUsers) => [...prevUsers, newUser]);
  };

  const updateUser = (updatedUser) => {
    setUsers((prevUsers) =>
      prevUsers.map((user) => (user.id === updatedUser.id ? updatedUser : user))
    );
  };

  return (
    <div className="container mt-4 pb-5">
      <h1 className="text-center">Gestión de Usuarios</h1>

      {/* Carga y error */}
      {loading && <p className="alert alert-info text-center">Cargando usuarios...</p>}
      {error && <p className="alert alert-danger text-center">Error al obtener usuarios: {error.message}</p>}

      {/* Mostrar tabla de usuarios si no hay errores ni carga */}
      {!loading && !error && users.length > 0 ? (
        <UsersTable users={users} updateUser={updateUser} refetch={refetch} />
      ) : (
        <p className="text-center text-muted">No hay usuarios disponibles.</p>
      )}

      {/* Botón flotante para agregar usuario */}
      {!showForm && (
        <button
          className="btn position-fixed bottom-3 end-0 me-4 mb-4 rounded-circle p-3 shadow-lg d-flex align-items-center justify-content-center"
          onClick={() => setShowForm(true)}
          aria-label="Nuevo usuario"
          title="Agregar nuevo usuario"
          style={{
            background: "linear-gradient(135deg, #007bff, #6610f2)",
            color: "white",
            fontSize: "1.5rem",
            border: "none",
            width: "60px",
            height: "60px",
            transition: "transform 0.2s ease, box-shadow 0.3s ease",
            zIndex: 1050,
            bottom: '70px' // Ajusta este valor para bajar el botón
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "scale(1.1)";
            e.currentTarget.style.boxShadow = "0px 0px 15px rgba(102, 16, 242, 0.6)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "scale(1)";
            e.currentTarget.style.boxShadow = "0px 4px 10px rgba(0, 0, 0, 0.2)";
          }}
        >
          <FaPlus size={24} />
        </button>
      )}

      {/* Formulario de usuario */}
      {showForm && (
        <div className="mt-4">
          <UserForm setShowForm={setShowForm} updateUsers={updateUsers} />
        </div>
      )}
    </div>
  );
}

export default Users;
